// Copyright (C) 2021 TANNER AG

import React, { useState } from "react";
import { compose } from "recompose";
import { withStyles } from "@material-ui/core/styles";
import { Link, withRouter } from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ArrowIcon from "@material-ui/icons/NavigateNext";
import Heading4 from "../styleguide/Heading4";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";

const styles = (theme) => ({
    link: {
        textTransform: "uppercase",
        fontSize: 14,
        fontFamily: "'MANEurope', sans-serif",
        fontWeight: 700,
        color: "#303C49",
        textDecoration: "none",
        cursor: "pointer",

        "&:hover, &:focus": {
            color: "#e40045",
        },
    },
    menuPaperStyle: {
        borderRadius: 0,
        width: "100%",
        backgroundColor: "transparent",
        boxShadow: "none",
        marginTop: 16,
    },
    menuInner: {
        padding: 16,
        paddingRight: 40,
        outline: 0,
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
        backgroundColor: "#fff",
        position: "relative",
        boxShadow:
            "0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)",
    },
    menuListStyle: {
        paddingTop: 0,
        paddingBottom: 0,
    },
    menuListHeadingStyle: {
        outline: 0,
        marginBottom: 16,
    },
    menuListItemStyle: {
        paddingRight: 0,
        paddingLeft: 0,
        display: "flex",
        alignItems: "center",
        borderTop: "1px solid rgba(0, 0, 0, 0.12)",
        maxWidth: 300,
    },
    menuListItemTextStyle: {
        marginRight: "auto",
        paddingRight: 12,
    },
    closeIcon: {
        position: "absolute",
        top: 0,
        right: 0,
    },
});

const HeaderMenuItem = ({ classes, entryScreenItem, history }) => {
    const [anchorEl, setAnchorEl] = useState();

    if (entryScreenItem.linkUrl) {
        if (entryScreenItem.linkUrl.startsWith("http")) {
            return (
                <a href={entryScreenItem.linkUrl} target="_blank" className={classes.link}>
                    {entryScreenItem.title}
                </a>
            );
        }

        return (
            <Link to={entryScreenItem.linkUrl} className={classes.link}>
                {entryScreenItem.title}
            </Link>
        );
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <a onClick={handleClick} className={classes.link}>
                {entryScreenItem.title}
            </a>
            <Menu
                classes={{ paper: classes.menuPaperStyle }}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: 140,
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                getContentAnchorEl={null}
                MenuListProps={{ className: classes.menuListStyle }}
                component="div"
            >
                <div className={classes.menuInner}>
                    <Heading4 className={classes.menuListHeadingStyle}>{entryScreenItem.title}</Heading4>
                    <IconButton className={classes.closeIcon} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                    {entryScreenItem.entryScreenSubItems.map((subItem) => (
                        <MenuItem
                            key={subItem.id}
                            onClick={() => {
                                history.push(subItem.linkUrl);
                                handleClose();
                            }}
                            className={classes.menuListItemStyle}
                        >
                            <span className={classes.menuListItemTextStyle}>{subItem.title}</span>
                            <ArrowIcon />
                        </MenuItem>
                    ))}
                </div>
            </Menu>
        </React.Fragment>
    );
};

export default compose(withStyles(styles), withRouter)(HeaderMenuItem);



// WEBPACK FOOTER //
// ./src/components/HeaderMenuItem.js